import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { ExternalLink } from 'lucide-react';

const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  try {
    return new Date(dateStr).toLocaleDateString('ro-RO', {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
    });
  } catch { return dateStr; }
};

const formatNumber = (num) => {
  if (num === undefined || num === null) return '-';
  return new Intl.NumberFormat('ro-RO').format(num);
};

export const LocationsTab = ({ locations }) => {
  return (
    <Card>
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="text-lg">Locatii Curente</CardTitle>
          <div className="flex gap-4 text-sm">
            <span className="text-slate-500">Total: <strong className="text-slate-900">{formatNumber(locations?.total_quantity)}</strong> buc</span>
            <span className="text-slate-500">BIN-uri: <strong className="text-slate-900">{locations?.unique_bins}</strong></span>
            <span className="text-slate-500">LOT-uri: <strong className="text-slate-900">{locations?.unique_lots}</strong></span>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Locatie BIN</TableHead>
              <TableHead>LOT / Batch</TableHead>
              <TableHead className="text-right">Cantitate</TableHead>
              <TableHead>Furnizor</TableHead>
              <TableHead>Data Intrare</TableHead>
              <TableHead>Vechime</TableHead>
              <TableHead className="text-center">Actiuni</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {locations?.locations?.map((loc, idx) => (
              <TableRow key={loc.id || idx}>
                <TableCell>
                  <div>
                    <p className="font-medium">{loc.bin_location}</p>
                    <p className="text-xs text-slate-500 font-mono">{loc.bin_code}</p>
                  </div>
                </TableCell>
                <TableCell>
                  {loc.lot_number ? <Badge variant="outline" className="font-mono text-xs">{loc.lot_number}</Badge> : '-'}
                </TableCell>
                <TableCell className="text-right font-semibold">{formatNumber(loc.quantity)}</TableCell>
                <TableCell>{loc.supplier_name || '-'}</TableCell>
                <TableCell className="text-sm">{formatDate(loc.entry_date)?.split(',')[0]}</TableCell>
                <TableCell>
                  {loc.age_days !== null ? (
                    <Badge variant={loc.age_days > 90 ? 'destructive' : loc.age_days > 30 ? 'warning' : 'secondary'}>
                      {loc.age_days} zile
                    </Badge>
                  ) : '-'}
                </TableCell>
                <TableCell className="text-center">
                  {loc.receipt_id && (
                    <Button size="sm" variant="ghost" className="h-7 px-2" onClick={() => window.location.href = `/wms/receipts?id=${loc.receipt_id}`}>
                      <ExternalLink className="w-3.5 h-3.5" />
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
            {locations?.locations?.length === 0 && (
              <TableRow>
                <TableCell colSpan={7} className="text-center py-8 text-slate-400">
                  Articolul nu are stoc in nicio locatie
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
